import { StyleSheet } from "react-native";

export const tposModeIconStyles = StyleSheet.create({
  container: {
    marginHorizontal: 10,
    width: 55,
    height: 55,
  },
  icon: {
    height: 55,
    width: 55,
  },
});
